export const getRouteUrlWithParams = (path: string, params: Record<string, string | number> = {}): string => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    urlParams.set(key, String(value));
  });

  return `${path}?${urlParams.toString()}`;
};
